import React from "react";
import { Instagram, Facebook, Mail } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M16.5 3c.3 2.2 1.6 3.6 3.7 3.8v2.4c-1.3.1-2.5-.3-3.7-1v5.7c0 3.6-2.9 6.1-6.2 5.7-2.9-.3-4.9-2.7-4.7-5.6.2-2.7 2.5-4.7 5.2-4.6.3 0 .5 0 .8.1v2.5c-.3-.1-.6-.1-.9-.1-1.2 0-2.2 1-2.2 2.2 0 1.3 1.1 2.3 2.4 2.2 1.2-.1 2-1.1 2-2.4V3h3.6z" />
  </svg>
);

const NAV = [
  { label: "Mission", href: "#mission" },
  { label: "Tiers", href: "#tiers" },
  { label: "Intel", href: "#faq" },
];

const CONTACT = "hello@theowlofmintaka.com";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="footer-section" className="relative border-t border-sf-border py-14">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <div className="sf-stencil text-xl tracking-[0.18em] text-sf-bone">
              <span className="text-sf-ember">/</span>SACRED FRONTLINE
            </div>
            <p className="mt-3 text-sm text-sf-dim max-w-xs">
              Messages for the protectors, the wounded, and the awakened.
            </p>
          </div>

          <nav className="flex gap-6">
            {NAV.map((n) => (
              <button
                key={n.href}
                onClick={() => go(n.href)}
                className="font-mono text-xs uppercase tracking-[0.2em] text-sf-dim hover:text-sf-bone transition-colors"
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex flex-col gap-3">
            <div className="flex gap-4 text-sf-dim">
              <a href="https://instagram.com/theowlofmintaka" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-sf-ember transition-colors"><Instagram size={18} /></a>
              <a href="https://tiktok.com/@theowlofmintaka" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-sf-ember transition-colors"><TikTokIcon /></a>
              <a href="https://facebook.com/theowlofmintaka" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-sf-ember transition-colors"><Facebook size={18} /></a>
            </div>
            <a href={`mailto:${CONTACT}`} className="flex items-center gap-2 font-mono text-xs text-sf-dim hover:text-sf-bone transition-colors">
              <Mail size={14} /> {CONTACT}
            </a>
            <a href="https://www.theowlofmintaka.com" target="_blank" rel="noopener noreferrer" data-testid="footer-social-website" className="font-mono text-xs text-sf-muted hover:text-sf-ember transition-colors">
              www.theowlofmintaka.com
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-sf-border flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] uppercase tracking-[0.15em] text-sf-muted">
          <span>
            © {new Date().getFullYear()} Sacred Frontline ·{" "}
            <a
              href="https://www.theowlofmintaka.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-website-link"
              className="text-sf-dim hover:text-sf-ember transition-colors"
            >
              www.theowlofmintaka.com
            </a>
          </span>
          <span>All decks hand-illustrated. Made for the frontline.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
